/*
  Add Custom JS to be layered on top of ciritical theme js
*/

window.addEventListener('authentic:membership-added', () => { 
    window.Neptune.cart.getCart();
    window.dispatchEvent(new Event('initCart'));
    document.querySelector('.tools__button--cart')?.click();
});
